import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Custom hook to extract and manage permissions for the Leader tool.
 * Handles the calculation of read-only mode based on tool settings.
 * 
 * @returns {Object} result
 * @returns {boolean} result.isReadOnly - Whether the user has personal-only access
 * @returns {string} result.accessLevel - The specific access level ('full' | 'personal_only')
 * @returns {Object} result.settings - The raw tool settings
 */
export function useLeaderPermissions() {
    const { toolPermissions } = useAuth();

    const result = useMemo(() => {
        const perms = toolPermissions?.['leader']?.permissions || {};
        const settings = toolPermissions?.['leader']?.settings || {};
        
        // Unify: Check permissions (where AdminPanel saves) and fallback to settings
        const accessLevel = perms.accessLevel || settings.accessLevel || 'full';
        const isReadOnly = accessLevel === 'personal_only';

        return {
            isReadOnly,
            accessLevel,
            settings: { ...settings, ...perms } // Merge for reliability
        };
    }, [toolPermissions]);

    return result;
}
